import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb36079c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./home.scss?vue&type=style&index=0&id=cb36079c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb36079c",
  null
  
)

export default component.exports